<template>
<!-- <div> -->
  <v-dialog v-model="bMostrarModal" persistent max-width="680px">
    <v-card>
      <v-toolbar
        color="headformsdark"
        height="45"
        elevation="0"
        dense
        dark>
        <v-spacer></v-spacer>
        <span class="mdlHeadForms">Imágenes</span>
        <v-spacer></v-spacer>
        <v-btn 
          color="btncolor-dark"
          @click="CloseDialog()"
          icon
          small
          dark
          outlined>
          <v-icon size="14px">fa fa-times</v-icon>
        </v-btn>
      </v-toolbar>
        <!-- <section> -->
      <v-card-text class="pa-1">
        <v-row class="no-gutters"  v-if="bCargando">
          <v-col cols="12" class="mx-auto" >
              <v-skeleton-loader
                class="mx-auto"
                max-width="300"
                type="card"
              ></v-skeleton-loader>
          </v-col>
        </v-row>
        <v-row class="no-gutters" v-else-if="aData.length == 0" >
          <v-col cols="12" class="text-center pa-1 under-sec-flat-gray">
            <v-icon color="primary" class="animated bounceIn dura-1" size="60px">mdi-information</v-icon>
            <h2 class="text-medium text-primary font-size-1">
              Sin información para mostrar
            </h2>
          </v-col>
        </v-row>
        <v-row class="no-gutters" v-else>
          <v-col cols="12" sm="6" class="mx-auto" style="overflow:hidden;" v-for="(oItem, nIndex) in aData" :key="nIndex" >
            <v-card class="ma-1 border-card text-center animated flipInX">
              <v-card-text class="ColumnaResumida under-sec-flat titlesdark--text py-1 px-2">
                   {{$store.state.jsIdioma.oEquivalencias.lblNumeroFotografia}} {{nIndex+1}}
              </v-card-text>
              <v-card-text class="text-center pa-0">
                <v-img
                  :lazy-src="oItem[oCampos.sAnexo]"
                  aspect-ratio=".8"
                  max-width="70%"
                  :src="oItem[oCampos.sAnexo]"
                  class="margin-auto"
                >
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="grey lighten-5"
                    ></v-progress-circular>
                  </v-row>
                </template>
                </v-img>
              </v-card-text>
            </v-card>  
          </v-col>
        </v-row>
      </v-card-text>
    <!-- </section> -->
    </v-card>  


  </v-dialog>
            
  <!-- </div> -->
</template>

<script>
import axiosServices from '@/services/axiosServices.js'
import oJsonAnexos from '@/assets/file/json_anexos.js'

export default {
  name:"ModalImagenes",
  props: {
    bMostrarModal: {
      type: Boolean,
      default: false
    },
    oDataParent: {
      type: Object,
      default: () => {}
    },
    
    sIdCampo: { // Se recibe el nombre del campo de la llave principapara extracto el id valor 
      type: String,
      default: ''
    },
    sNombreTabla: {
      type: String,
      default: ''
    },
  },
  // 
  components: {},
  data() {
      return {
        sIdLlaveForanea: '', // Indica elid d e filtro para traer la info
        aData:[], // Informacion de las firmas
        oCampos: {},
        bCargando: true,
      }
  },
  async mounted(){
    this.bCargando = true
    if(oJsonAnexos.hasOwnProperty(this.sNombreTabla.split('$')[0])){
      this.oCampos = oJsonAnexos[this.sNombreTabla.split('$')[0]].oFotos
      //console.log(this.oCampos)
      this.sIdLlaveForanea = this.oDataParent[this.sIdCampo]
      //Se agreg el id del cliente para la carga de imagenes de seif modulos
      let sParamIdCliente = this.oDataParent['idCliente']!=undefined?'&nIdCliente='+this.oDataParent['idCliente']:'';
      var  sParams = '&nTipo=1&sTabla='+ oJsonAnexos[this.sNombreTabla.split('$')[0]].oFotos.sTablaAnexos + '&' + 'nValor=' + this.sIdLlaveForanea + `&oCampos=${JSON.stringify(this.oCampos)}${sParamIdCliente}` 
      
      const  aRespuesta = await axiosServices.getConfiguration('/pGrids_Anexos', true ,sParams)
      this.aData = aRespuesta.aData
    }
    this.bCargando = false
  },
  methods: {
    CloseDialog() {
      this.$emit('input', false)
    },
  },
  
}
</script>

<style lang="scss" scoped>

</style>